import React, { useState, useEffect, useCallback } from 'react'
import { storeContext } from '../../context';
import { Layout, Button, Table, Col, Row, Form, Input } from 'antd';
import translate from '../../i18n/translate';
import api from '../../helpers/api';
import { getError } from '../../helpers/verifyStatusErrorResponse';
import AlertNotAllow from '../AlertNotAllow';
import Confirm from '../Confirm/Confirm';
import CustomAutoComplete from '../CustomAutoComplete';
import { Bus } from '../../helpers/utils';
const { Content } = Layout;
const labelCol = {
    xs: 24,
    sm: 24,
    md: 12,
    lg: 12,
    xl: 10,
};
const VALUE_DEFAULT = {
    network_id: '5bbd0d144051a50034cd19fb',
    connector_id: '5f5a8f3351d4db99c40dece5'
};
const DATA_DEFAULT = { count: 0, result: [] };
const PAGINATION_DEFAULT = { pageSize: 15, current: 0 };

export default function AsType({ setId }) {
    const store = React.useContext(storeContext);
    const [data, setData] = useState(DATA_DEFAULT);
    const [state, setState] = useState(VALUE_DEFAULT);
    const [permission, setPermission] = useState(true);
    const [loading, setLoading] = useState(false);
    const [loadingButton, setLoadingButton] = useState(false);

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: translate('default.name'),
            dataIndex: 'name',
            key: 'name',
            sorter: true,
        },
        {
            title: translate('default.description'),
            dataIndex: 'description',
            key: 'description',
            sorter: true,
        },
        {
            title: translate('application.name'),
            dataIndex: 'application',
            key: 'application',
            sorter: true,
        },
        {
            title: '',
            align: 'right',
            key: 'action',
            width: 200,
            render: (text, record, index) => (
                <>
                    <Button icon="edit" type="default" onClick={() => {
                        store.currentItem.asTypeId = record.id;
                        setId(record.id);
                        setState({ ...record, index });
                    }} htmlType="button" style={{ marginRight: 10 }} />
                    <Button icon="delete" type="danger" onClick={() => Confirm({ func: () => remove(index) })} htmlType="button" />
                </>
            ),
        }
    ];

    async function remove(index) {
        try {
            setLoading(true);
            await api.delete(`/as_type/${data.result[index].id}`);
            await initialize(PAGINATION_DEFAULT);
            setId(null);
            setState(VALUE_DEFAULT);
        } catch (e) {
            setPermission(getError(e, store));
        }
        setLoading(false);
    }

    async function onAdd() {
        const model = {
            ...state,
            application_id: store.currentItem.id,
            application: store.currentItem.name
        }
        await api.post('/as_type', model);
    }

    async function onUpdate() {
        delete state.index;
        const model = {
            ...state,
            application_id: store.currentItem.id,
            application: store.currentItem.name
        }
        await api.put(`/as_type/${state.id}`, model);
    }

    async function onSubmit(event) {
        event.preventDefault();
        try {
            setLoadingButton(true);
            setLoading(true);
            if (state.id) {
                await onUpdate();
            } else {
                await onAdd();
            }
            store.success = { message: translate('asType.save') }
            await initialize(PAGINATION_DEFAULT);
            setId(null);
            setState(VALUE_DEFAULT);
        } catch (e) {
            setPermission(getError(e, store));
        }
        setLoadingButton(false);
        setLoading(false);
    }

    function setAsDeviceMappingLevelId(as_device_mapping_as_level_id) {
        state.as_device_mapping_as_level_id = as_device_mapping_as_level_id;
        setState(state);
    }
    function confirmCreateAsDeviceMapping() {
        const content = (
            <Form layout="vertical">
                <Row gutter={16}>
                    <Col >
                        <Form.Item label={translate('asLevel.name')}>
                            <CustomAutoComplete
                                searchValue={'id'}
                                searchKey={'name'}
                                path={`/as_level/application/${store.currentItem.id}`}
                                onSelect={(as_device_mapping_as_level_id) => setAsDeviceMappingLevelId(as_device_mapping_as_level_id)}
                                value={state.as_device_mapping_as_level_id} />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        );
        Confirm({
            func: () => createAsDeviceMapping(), content, width: 600, okText: translate('asDeviceMapping.createMigration'),
            title: translate('asDeviceMapping.name')
        })
    }

    async function createAsDeviceMapping() {
        const model = {
            name: state.name,
            application_id: store.currentItem.id,
            as_type_id: state.id,
            as_level_id: state.as_device_mapping_as_level_id,
        };
        try {
            setState(prevState => ({ ...prevState, loading_confirm_as_device_mapping: true }));
            await api.post('/as_device_mapping', model);
            store.success = { message: translate('asDeviceMapping.save') }
            setState(prevState => ({ ...prevState, has_as_device_mapping: 1 }));
            data.result[state.index].has_as_device_mapping = 1;
            setData(data);
            Bus.emit("addAsDeviceMappingByType");
        } catch (error) {
            setPermission(getError(error, store));
        } finally {
            setLoadingButton(false);
            setState(prevState => ({ ...prevState, loading_confirm_as_device_mapping: false }));
        }
    }

    function isDisabled() {
        return !state || !state.name
            || !state.description || !state.network_id
            || !state.connector_id;
    }

    const initialize = useCallback(async ({ current = 0, pageSize = 15 }) => {
        setLoading(true);
        try {
            const offset = current ? ((pageSize * current) - pageSize) : 0;
            const data = await api.get(`/as_type?application=${store.currentItem.id}&limit=${pageSize}&offset=${offset}`);
            if (data.data && data.data.result) {
                return setData(data.data);
            }
            setData(DATA_DEFAULT);
        } catch (e) {
            setPermission(getError(e, store));
        } finally {
            setLoading(false);
        }
        // eslint-disable-next-line
    }, [store.currentItem.id]);

    useEffect(() => {
        initialize(PAGINATION_DEFAULT);
    }, [initialize]);

    return (
        <Content className="padding-20">
            {permission ?
                <>
                    <Form layout="vertical" onSubmit={onSubmit}>
                        <Row gutter={16}>
                            <Col {...labelCol}>
                                <Form.Item label="Id">
                                    <Input value={state.id} disabled={true} />
                                </Form.Item>
                            </Col>
                            <Col {...labelCol}>
                                <Form.Item label={translate('default.name')} required>
                                    <Input value={state.name}
                                        onChange={(e) => {
                                            const name = e.target.value;
                                            setState(prevState => ({ ...prevState, name }));
                                        }} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col {...labelCol}>
                                <Form.Item label={translate('default.description')} required>
                                    <Input value={state.description}
                                        onChange={(e) => {
                                            const description = e.target.value;
                                            setState(prevState => ({ ...prevState, description }));
                                        }} />
                                </Form.Item>
                            </Col>
                            <Col {...labelCol}>
                                <Form.Item label={translate('application.name')} required>
                                    <Input disabled={true} value={store.currentItem.name} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col {...labelCol}>
                                <Form.Item label="Network">
                                    <CustomAutoComplete
                                        key={state.id}
                                        searchValue={'id'}
                                        searchKey={'name'}
                                        path={`/tago/network/application/${store.currentItem.id}`}
                                        onSelect={(network_id) => setState(prevState => ({ ...prevState, network_id }))}
                                        value={state.network_id} />
                                </Form.Item>
                            </Col>
                            <Col {...labelCol}>
                                <Form.Item label="Connector">
                                    <CustomAutoComplete
                                        notRequest={!state.network_id}
                                        key={`${state.network_id} ${state.id}`}
                                        disabled={!state.network_id}
                                        searchValue={'id'}
                                        searchKey={'name'}
                                        path={`/tago/connector/application/network/${store.currentItem.id}/${state.network_id}`}
                                        onSelect={(connector_id) => setState(prevState => ({ ...prevState, connector_id }))}
                                        value={state.connector_id} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col>
                                <Form.Item>
                                    <Button loading={loadingButton} type="primary" disabled={isDisabled()} htmlType="submit" >
                                        {state.id ? translate('default.save') : translate('default.add')}
                                    </Button>
                                    <Button htmlType="button" style={{ marginLeft: 10 }} onClick={() => {
                                        setState(VALUE_DEFAULT);
                                        setId(null);
                                    }}>
                                        {translate('default.cancel')}
                                    </Button>
                                    <Button loading={state.loading_confirm_as_device_mapping} disabled={!state.id || state.has_as_device_mapping || !state.name} type="dashed" htmlType="button" style={{ marginLeft: 10 }}
                                        onClick={() => confirmCreateAsDeviceMapping()}>
                                        {translate('asDeviceMapping.createMigration')}
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    <Col>
                        <Table
                            size="small"
                            rowKey={(record, index) => index}
                            columns={columns}
                            dataSource={data.result}
                            loading={loading}
                            onChange={(pagination) => initialize(pagination)}
                            pagination={{
                                pageSize: 15,
                                total: data.count || 0
                            }}
                        />
                    </Col>
                </>
                : (
                    <AlertNotAllow />
                )}
        </Content>
    )
}
